import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiExpectedReceivablesByDate = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbydate/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiExpectedReceivablesByDateTotal = async (accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbydate/total/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiExpectedReceivablesByDateNext = async (accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbydate/next/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiExpectedReceivablesByAccount = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbyaccount/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiExpectedReceivablesByProduct = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/expectedreceivablesbyproduct/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiAccountExpectedReceivablesComparison = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/accountexpectedreceivablescomparison/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
